var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAttatchment = function SvgAttatchment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    d: "m16.147 9.873-5.871 5.871c-1.598 1.598-3.995 1.787-5.624.158-1.598-1.598-1.39-3.913.239-5.543l6.6-6.6a2.573 2.573 0 0 1 3.646 0 2.573 2.573 0 0 1 0 3.647L8.42 14.122a1.29 1.29 0 0 1-1.823-1.824l5.987-5.987"
  })));
};
export default SvgAttatchment;